import React from 'react';

const NotFound = () => {
    return (
        <React.Fragment>
            not found!
        </React.Fragment>
    );
}

export default NotFound;